import {RouteConfig} from 'vue-router'
import DashboardLayout from 'src/components/Dashboard/Layout/DashboardLayout.vue'

// Pages
import Login from 'src/pages/Login.vue'
import NotFound from 'src/pages/NotFound.vue'
import AccessDenied from 'src/pages/AccessDenied.vue'

import profile from './routes/profile'
import mailings from './routes/mailing'
import mailingsStuff from './routes/mailing-stuff'
import settings from './routes/settings'
import staff from './routes/users'
import statistics from './routes/statistics'
import students from './routes/students'
import orgs from './routes/orgs'
import wiki from './routes/wiki'
import polls from './routes/polls'

// @ts-ignore
import messages from '@/lang/index';


const loginPage: RouteConfig = {
  path: '',
  name: 'login',
  component: Login
}

const access: RouteConfig = {
  path: '/access',
  name: 'access',
  component: DashboardLayout,
  redirect: 'access/denied',
  children: [
    {
      path: 'denied',
      name: 'accessDenied',
      meta: {
        pageName: messages.labels.access_closed
      },
      component: AccessDenied
    }
  ]
}

const routes: RouteConfig[] = [
  loginPage
]

export default routes